import { safeJsonParse } from '@utility/helperFunction';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const deviceGroup = safeJsonParse(window.sessionStorage.getItem('deviceInfo'), {})?.deviceGroup;

const statusOptions = () => {
  return [
    { label: FLABEL().STATUS_PENDING, value: 'Pending' },
    { label: FLABEL().STATUS_PROGRESS, value: 'In Progress' },
    { label: FLABEL().STATUS_COMPLETE, value: 'Complete' },
    { label: FLABEL().STATUS_PICKEDUP, value: 'Picked Up' },
    { label: FLABEL().STATUS_SEE_COUNTER, value: 'See Counter' },
    { label: FLABEL().STATUS_OPEN, value: 'Open' },
    { label: FLABEL().STATUS_CANCELLED, value: 'Cancelled' },
    { label: FLABEL().STATUS_ERROR, value: 'Error' },
  ];
};


const buildFilterOptions = ({
    allOptions = [],
    matchKey,
    labelKey,
    valueKey,
    id,
}) => {
    const selectedIds = deviceGroup?.fireBoardCheckFilters;
    if (!selectedIds || selectedIds.length === 0) {
        return allOptions.map(opt => ({
            label: opt[labelKey],
            value: opt[valueKey],
            id: opt[id]
        }));
    }

    const optionMap = new Map(
        allOptions.map(opt => [opt[matchKey], opt])
    );

    return selectedIds
        .map(id => optionMap.get(id))
        .filter(Boolean)
        .map(opt => ({
            label: opt[labelKey],
            value: opt[valueKey],
            id: opt[id],
        }));
};

export const getFilterModes = ({
    venuesInfo,
    storeInfo,
}) => {
    const channelOptions = [
        { label: FLABEL().CHANNEL_POS, value: 'POS', sourceType: 0 },
        { label: FLABEL().CHANNEL_KIOSK, value: 'Kiosk', sourceType: 1 },
        { label: FLABEL().CHANNEL_CURBSIDE, value: 'Curbside', sourceType: 5 },
        { label: FLABEL().CHANNEL_ONLINE, value: 'Online', sourceType: 6 },
        { label: FLABEL().CHANNEL_WALKUP, value: 'Walk up', sourceType: 7 },
        { label: FLABEL().CHANNEL_CALL_IN, value: 'Call in', sourceType: 8 },
        { label: FLABEL().CHANNEL_COUNTER, value: 'Counter', sourceType: 9 },
        { label: FLABEL().CHANNEL_CALL_CENTER, value: 'Call Center', sourceType: 10 },
        { label: FLABEL().CHANNEL_SPEED_ORDER, value: 'Speed Order', sourceType: 11 },
        { label: FLABEL().CHANNEL_DRIVE_THRU, value: 'Drive Thru', sourceType: 12 },
        { label: FLABEL().CHANNEL_ORDER_PAY, value: 'Order Pay', sourceType: 3 },
    ]

    const channelsToShow = buildFilterOptions({
        allOptions: channelOptions,
        matchKey: 'sourceType',
        labelKey: 'label',
        valueKey: 'value',
    });

    const orderTypesToShow = buildFilterOptions({
        allOptions: storeInfo?.orderTypes || [],
        matchKey: 'masterId',
        labelKey: 'name',
        valueKey: 'masterId',
        id: 'id',
    });

    const revenueCentersToShow = buildFilterOptions({
        allOptions: storeInfo?.revenueCenters || [],
        matchKey: 'masterId',
        labelKey: 'name',
        valueKey: 'masterId', // using for filtering in dropdowns
        id: 'id', // using for filtering in list
    });

    const employeeOptions =
        storeInfo?.employees
            ?.filter(e => e?.firstName?.trim())
            ?.map(e => ({
                label: `${e.firstName} ${e.lastName || ''}`,
                value: e.externalId,
            })) || [];

    const locationOptions =
        venuesInfo?.saStoreInfos?.map(store => ({
            id: store.id,
            label: store.name,
            value: store.id,
        })) || [];

    return {
        DEFAULT: {
            filters: [
                { name: 'Location', lable: FLABEL().HEADER_LOCATION, options: locationOptions, isMulti: true, maxToShow: 1 },
                { name: 'Channel', lable: FLABEL().HEADER_CHANNEL, options: channelsToShow, isMulti: true, maxToShow: 1 },
                { name: 'Order Type', lable: FLABEL().HEADER_ORDER_TYPE, options: orderTypesToShow, isMulti: true, maxToShow: 1 },
                { name: 'Revenue Center', lable: FLABEL().HEADER_REVENUE_CENTER, options: revenueCentersToShow, isMulti: true, maxToShow: 1 },
                { name: 'Status', lable: FLABEL().HEADER_STATUS, options: statusOptions(), isMulti: true, maxToShow: 1 },
            ],
            toggles: [
                { name: 'paidAndUnpaid', defaultValue: false, labels: [FLABEL().HEADER_ALL, FLABEL().HEADER_UNPAID] },
            ],
        },

        ON_PREMISE: {
            filters: [
                { name: 'Location', lable: FLABEL().HEADER_LOCATION, options: locationOptions, isMulti: true, maxToShow: 1 },
                { name: 'Channel', lable: FLABEL().HEADER_CHANNEL, options: channelsToShow, isMulti: true, maxToShow: 1 },
                { name: 'Order Type', lable: FLABEL().HEADER_ORDER_TYPE, options: orderTypesToShow, isMulti: true, maxToShow: 1 },
                { name: 'Revenue Center', lable: FLABEL().HEADER_REVENUE_CENTER, options: revenueCentersToShow, isMulti: true, maxToShow: 1 },
                { name: 'Employee', lable: FLABEL().HEADER_EMPLOYEE, options: employeeOptions, isMulti: true, maxToShow: 1, isSearchable: true },
            ],
            toggles: [
                { name: 'paidAndUnpaid', defaultValue: false, labels: [FLABEL().HEADER_ALL, FLABEL().HEADER_UNPAID] },
            ],
        },

        OFF_PREMISE: {
            filters: [
                { name: 'Location', lable: FLABEL().HEADER_LOCATION, options: locationOptions, isMulti: true, maxToShow: 1 },
                { name: 'Channel', lable: FLABEL().HEADER_CHANNEL, options: channelsToShow, isMulti: true, maxToShow: 1 },
                { name: 'Order Type', lable: FLABEL().HEADER_ORDER_TYPE, options: orderTypesToShow, isMulti: true, maxToShow: 1 },
                { name: 'Revenue Center', lable: FLABEL().HEADER_REVENUE_CENTER, options: revenueCentersToShow, isMulti: true, maxToShow: 1 },
                { name: 'Status', lable: FLABEL().HEADER_STATUS, options: statusOptions(), isMulti: true, maxToShow: 1 },
            ],
            toggles: [
                { name: 'paidAndUnpaid', defaultValue: false, labels: [FLABEL().HEADER_ALL, FLABEL().HEADER_UNPAID] },
            ],
        },

        TABLE_DELIVERY: {
            filters: [
                { name: 'Location', lable: FLABEL().HEADER_LOCATION, options: locationOptions, isMulti: true, maxToShow: 1 },
                { name: 'Channel', lable: FLABEL().HEADER_CHANNEL, options: channelsToShow, isMulti: true, maxToShow: 1 },
                { name: 'Order Type', lable: FLABEL().HEADER_ORDER_TYPE, options: orderTypesToShow, isMulti: true, maxToShow: 1 },
                { name: 'Revenue Center', lable: FLABEL().HEADER_REVENUE_CENTER, options: revenueCentersToShow, isMulti: true, maxToShow: 1 },
                { name: 'Status', lable: FLABEL().HEADER_STATUS, options: statusOptions(), isMulti: true, maxToShow: 1 },
            ],
            toggles: [],
        },

        FUTURE_ORDERS: {
            filters: [],
        },
    };
};
